import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Molina Healthcare",
  shortName: "Molina",
  slug: "molina-insurance",
  seoTitle: "Molina Healthcare TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Molina Healthcare insurance? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Molina plan in Coral Springs, FL.",
  seoKeywords:
    "Molina Healthcare TMS coverage, Molina TMS therapy, Molina depression treatment Florida, Molina mental health benefits Coral Springs FL, Molina SAINT TMS",
  planType: "Medicaid and Marketplace health insurance provider",
  planRegion: "Florida, California, Texas, and select states",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "Molina Healthcare is a health insurance provider focused on Medicaid, Medicare, and Marketplace plans, serving members in Florida and other states. Molina plans include behavioral health benefits that may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Molina offers different plan types — including Medicaid managed care, Marketplace, and Medicare-Medicaid dual plans — coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly depending on your specific plan, network, and state of enrollment.",
  officialResourceUrl: "https://www.molinahealthcare.com/",
  officialResourceLabel: "Molina Healthcare official website",
};

export const MolinaInsurance = () => <InsurancePageTemplate config={config} />;
export default MolinaInsurance;
